import styled from 'styled-components'

import { Modal } from '@sainsburys-tech/bolt'
import { SwatchesIcon } from '@sainsburys-tech/bolt-icons'

const OrderSwatch = styled.div`
  display: flex;
  cursor: pointer;
`

const OrderSwatchIcon = styled(SwatchesIcon)`
  width: 24px;
  height: 24px;
  margin-right: 6px;
  top: 0;
`

const IframeContainer = styled.div`
  display: ${props => (props.show ? 'block' : 'none')};
  height: 100vh;
  max-height: 100%;
  width: 100%;

  iframe {
    height: 100vh;
    max-height: 100%;
    width: 100%;
  }
`

// This is needed to allow the modal footer content to scroll, otherwise it doesnt fit and you cannot see all the terms and conditions
const ScrollableModal = styled(Modal)`
  overflow-y: auto;
`

const SpinnerWrapper = styled.div`
  display: ${props => (props.show ? 'block' : 'none')};
  width: 100px;
  margin: auto;
  div {
    top: 50%;
  }
`

const List = styled.ol`
  li {
    margin: 7px;
  }
`

export { OrderSwatch, OrderSwatchIcon, IframeContainer, SpinnerWrapper, List, ScrollableModal }
